import React from 'react';
import { Target } from 'lucide-react';

const VisionSection: React.FC = () => {
  return (
    <section className="py-24 bg-primary-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/2079246/pexels-photo-2079246.jpeg?auto=compress&cs=tinysrgb&w=1920')] bg-cover bg-center mix-blend-overlay"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-white/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <Target className="w-8 h-8 text-accent-400" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6">
            Helping Solve the UK Housing Shortage
          </h2>
          <p className="text-xl text-white/90">
            We're on a mission to create 100 residential units within five years—offering high-quality 
            housing options while revitalising town centres and unlocking hidden value for property 
            owners and investors.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;